import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { TableContainer } from 'components/DefaultTable/styles';

import colors from 'themes/Main';

const { darkBlue, gray03, danger, success, white } = colors;

export const Table = styled(TableContainer)`
  tbody tr td {
    &:first-child {
      width: 15vw;
    }

    &:nth-child(2),
    &:nth-child(3) {
      width: 20vw;
    }
  }

  tbody tr {
    cursor: default;

    &:hover {
      background-color: ${white};
    }
  }

  thead tr th:nth-child(4),
  thead tr th:last-child,
  tbody tr td:nth-child(4),
  tbody tr td:last-child {
    text-align: center;
  }

  td {
    &.status-inativo {
      font-weight: 700;
      color: ${danger};
    }

    &.status-ativo {
      font-weight: 700;
      color: ${success};
    }
  }
`;

export const EditClient = styled(Link)`
  display: block;

  &:hover {
    opacity: 0.7;
  }

  svg path {
    fill: ${darkBlue};
  }
`;

export const Callback = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 64px;
`;

export const CallbackText = styled.h2`
  width: 500px;
  margin-top: 32px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${gray03};
  text-align: center;

  p {
    display: block;
    margin-bottom: 8px;
  }
`;

export const Loader = styled.div`
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
`;
